import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
//@ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AuthGuard } from '@next/core-lib';

import { AgrPageToolbarModule, AgrPrimaryActionModule } from '@next/core-lib/components';

import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { provideAgrI18n } from '@next/core-lib/i18n';
import { provideEffects } from '@ngrx/effects';

import { RequestConfirmationScreenComponent } from './request-confirmation/request-confirmation-screen.component';

import { RequestComponent } from './request.component';
import { SharedModule } from '../shared/shared.module';
import { RequestEffects } from './store/effects/request.effects';

@NgModule({
  declarations: [RequestComponent, RequestConfirmationScreenComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    AgrPageToolbarModule,
    AgrPrimaryActionModule,
    AgrFormModule,
    MatSelectModule,
    MatTooltipModule,
    MatRadioModule,
    MatInputModule,
    AgrFormModule,
    AgrDialogModule,
    MatDialogModule,
  ],
  providers: [provideEffects([RequestEffects]), provideAgrI18n()],
})
export class RequestModule {}
